import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import NotificationFlag from "./components/NotificationFlag";

// eslint-disable-next-line no-undef
ReactDOM.render(<App />, document.getElementById("app-root"));
